import { Facebook, Instagram, Twitter } from "@material-ui/icons";
import React, { useCallback, useState, useEffect, useRef } from "react";
import Logo from "../../../assets/icons/TampleShalom.svg";
import easeyLogo from "../../../assets/icons/power-by.png";
import Logo2 from "../../../assets/icons/logo2.png";
import eazyTempleLogo from "../../../assets/icons/easytemplelogo.png";
import fbIcon from "../../../assets/icons/fb-icon.svg";
import instaIcon from "../../../assets/icons/insta-icon.svg";
import twitterIcon from "../../../assets/icons/twitter-icon.svg";

import "./index.scss";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import Doc from "components/PdfServiceDpcument/PdfServiceDpcument";
import { da } from "date-fns/locale";
import { useSelector } from "react-redux";
import { fontConfig } from "theme/fontConfig";

const ThankYouLetter = ({ setViewDoc, thankYouLetterView, data }) => {
  const inputRef = useRef(null);
  const [websiteLogo, setWebsiteLogo] = useState("");

  const DummyLogo = localStorage.getItem("Base64");

  const test = useCallback(() => {
    if (thankYouLetterView === false) {
      Doc.createPdf(inputRef.current);
      setTimeout(() => {
        setViewDoc(false);
      }, 1000);
    }
  });

  useEffect(() => {
    test();
  }, []);
  const logoImg = () => {
    setWebsiteLogo(localStorage.getItem("organization"));
  };

  useEffect(() => {
    window.addEventListener("logoImg", logoImg);
    return () => {
      window.removeEventListener("logoImg", logoImg);
    };
  }, []);
  const orgDetails = JSON.parse(localStorage.getItem("organization"));
  // console.log("orgName", orgDetails.orgName);

  return (
    <div className="letter-main" ref={inputRef}>
      <div className="container mt-3">
        <div className="letter-flex bord mb-12">
          <img src={DummyLogo} width="200px" />
          <p className="mr-8">Thank You</p>
        </div>
        <div className="mt-5 ml-7 mr-7">
          <p className="name">
            {data?.tribute_info?.donor_salutation
              ? data?.tribute_info?.donor_salutation + "."
              : ""}
            {data?.tribute_info?.donor_name}
          </p>
          <p className="mb-6">
            You recieved a donation of{" "}
            <span className="amount"> ${data?.total_amount}</span>
            <span /> from our donors.
          </p>
          <hr />
          {/* <p className="my-6 body-p">
            you can collect them just by clicking the button below
          </p>
          <p className="mb-6 body-p">
            In publishing and graphic design, Lorem ipsum is a placeholder text
            commonly used to demonstrate the visual form of a document or a
            typeface without relying on meaningful content. Lorem ipsum may be
            used as a placeholder before final copy is available.
          </p> */}
          <strong className="text-start body-p" style={{ fontSize: "16px" }}>
            Thank you
          </strong>
          <p className="body-p">
            {orgDetails.orgName} by <a className="aTag"> Easyshul </a>
          </p>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#2555ef",
          padding: "30px 40px",
          marginTop: "65px",
        }}
      >
        <table
          style={{
            tableLayout: "fixed",
            width: "100%",
            fontFamily: fontConfig.DonationsThankYouLetterTextFont.family,
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "100%" }} colspan="100%">
                <p
                  style={{
                    fontSize: "14px",
                    color: "#fff",
                    fontFamily: fontConfig.DonationsThankYouLetterTextFont.family,
                    padding: "15px 0px",
                    lineHeight: "25.2px",
                    borderBottom: "1px solid #fff",
                  }}
                >
                  This is not a tax invoice. This is a payment receipt for the
                  donation service provided to you by
                  <a
                    href=""
                    style={{
                      fontSize: "14px",
                      color: "#fff",
                      textDecoration: "underline",
                    }}
                  >
                    &nbsp; {orgDetails.orgName}
                  </a>
                  , &nbsp;and &nbsp;
                  <a
                    href=""
                    style={{
                      fontSize: "14px",
                      color: "#fff",
                      textDecoration: "underline",
                    }}
                  >
                    Easyshul &nbsp;
                  </a>
                  is acting as a payment agent on behalf of the{" "}
                  {orgDetails.orgName}.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ThankYouLetter;
